import clsx from 'clsx';
import GenericModal from 'components/common/GenericModal';
import { InputWithButton } from 'components/common/InputWithButton';
import ImageWithFallback from 'components/ImageWithFallback';
import { useState } from 'react';
import { trackEvent } from 'utils/analytics/analytics';
import { copyToClipboard } from 'utils/common';
import { APP_ENDPOINT } from 'utils/constants';
import styles from './inviteFriendsModal.module.css';
import Link from 'next/link';
import { useUIStore } from 'hooks/stores/useUIStore';
import { UIStore } from 'stores/UIStore';

export const InviteFriendsLinks = ({ referralId }: { referralId: string }) => {
  const [buttonText, setButtonText] = useState('copy');
  const inputValue = `https://${APP_ENDPOINT}?ri=${referralId}&utm_source=referral&utm_medium=invite_link&utm_campaign=2026_win_with_friends`;

  const copyInviteLink = () => {
    const successful = copyToClipboard(inputValue);
    if (successful) {
      setButtonText('copied!');
    }
    trackEvent('Win with Friends: Copy Link');
  };

  return (
    <div className={styles.inviteLinks}>
      <InputWithButton
        inputValue={inputValue}
        onClickButton={() => copyInviteLink()}
        buttonText={buttonText}
        readOnly
      />
    </div>
  );
};

export const InviteFriendsModal = ({
  referralId,
  hasReachedReferralLimit,
  isEligibleToRefer,
  handleClose,
}: {
  referralId: string;
  hasReachedReferralLimit: boolean;
  isEligibleToRefer: boolean;
  handleClose: () => void;
}) => {
  const uiStore = useUIStore();
  return (
    <GenericModal
      onClose={handleClose}
      style={{ maxWidth: '600px', padding: '40px 24px' }}
      noTextStyleOverrides
    >
      <div className={clsx(styles.container, 'aboutUsTypographyReset')}>
        {isEligibleToRefer
          ? hasReachedReferralLimit
            ? renderReferralLimitMessage()
            : renderReferralShareLink(referralId)
          : renderReferralNotAllowedMessage(uiStore)}
      </div>
    </GenericModal>
  );
};
function renderReferralNotAllowedMessage(uiStore: UIStore) {
  return (
    <>
      <div className={styles.header + ' withMinimalSpacing'}>
        <h2 className="aboutUsTypographyHeaderMedium">Not available</h2>
        <p className="textAlignCenter">
          Win with Friends is only available to active Premium players.{' '}
          <Link
            href="/account/subscriptions/upgrade"
            className="textDecorationUnderline"
            onClick={() => {
              uiStore.setShowInviteFriendsModal(false);
            }}>
            
              Upgrade to Premium
            
          </Link>{' '}
          to invite friends and earn referral rewards.
        </p>
      </div>
    </>
  );
}

function renderReferralLimitMessage() {
  return (
    <>
      <div className={styles.header + ' withMinimalSpacing'}>
        <div className={styles.winWithFriendsLimit}>
          <ImageWithFallback
            src="https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2026/referrals/limited-reached.png"
            layout="fill"
          />
        </div>
        <h2 className="aboutUsTypographyHeaderMedium">
          You filled all your spots!
        </h2>
        <p className="textAlignCenter">
          You’ve already invited the maximum of 3 friends - well done!
        </p>
      </div>
    </>
  );
}

function renderReferralShareLink(referralId: string) {
  return (
    <>
      <div className={styles.header}>
        <div className={styles.winWithFriendsBadge}>
          <ImageWithFallback
            src="https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2026/referrals/mascot-phone.png"
            layout="fill"
          />
        </div>
        <div className="aboutUsTypographyHeaderXlarge">Invite friends</div>
        <p>Invite up to 3 friends using your custom link below</p>
      </div>
      <div className={styles.links}>
        <InviteFriendsLinks referralId={referralId} />
      </div>
    </>
  );
}
